import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import { RouteWithTabs, buildThreePath } from 'helpers';
import { getFilters } from 'actions/customer';
const EMPTY_FILTER_OPTION = { value: -1, label: '-' };

import settingsService, { SORT_POSTFIX } from 'services/settingsService';

import CalendarContainer from 'components/Common/DatePicker/CalendarContainer';

import {Field, Form, getFormValues, reduxForm} from 'redux-form';
import { ComboBox, Input, DatePicker } from 'ui-core-dashboard';
import MultiSelectWithSearch from 'components/Common/MultiSelectWithSearch/ReduxFormDecorator';
import { renderDefaultFields, renderDateField } from 'components/FiltersForm/helpers';

import { bindActionCreators } from 'redux';
import { SEARCH_TIMER_INTERVAL } from 'constants/actions';
import { withTranslation } from 'react-i18next';
import Loader from "components/Loader";
import BaseService from '../../../../services/BaseService';

const mapDispatchToProps = dispatch => bindActionCreators({
	getFilters,
}, dispatch);

const mapStateToProps = (state, props) => ({
	form:props.form,
	filterList: state.customer.filterList,
	filterPresetList: state.customer.filterPresetList,
	tabEntity: state.customer.tabEntity,
	isFilterListLoading: state.customer.isFilterListLoading,
	formFilterValues: getFormValues(props.form)(state),
});


function SearchModalFilter (props){
	const { handleSubmit, t, formFilterValues, form, filterList, isFilterListLoading, tabEntity, filterPresetList  } = props;

    const [asyncState, setAsyncState] = useState({});

	
	useEffect(() =>{
		!filterList && props.getFilters(tabEntity);
	},[filterList]);
	
	const defaultPropsDate = {
		saveFormat: 'YYYY-MM-DDTHH:mm', locale: 'uk', popperContainer: CalendarContainer,
		showMonthDropdown: true, showYearDropdown: true
	};
	function getComponentByType (type, search) {
		let components = {
			LIST: ComboBox,
			NUMBER: Input,
			STRING: Input,
			DATE: DatePicker
		};
		
		if (search) {
			components = {
				THREE: MultiSelectWithSearch,
				LIST: MultiSelectWithSearch,
			};
		}
		
		return components[type] || Input;
	}
	
	const asyncParams = (search, code, id, type, onSuccess) => {
        if (!search) {
            setAsyncState({ [code]: [] });
        } else {
            BaseService.post("async_search_attributes", { data: { id, search }, jsonType: true }).then(resp => {
                if (type === "THREE") {
                    const ajaxOptions = { children: buildThreePath(resp.result, false, { children: "children" }) };
                    if (onSuccess && typeof onSuccess === 'function') {
                        onSuccess(ajaxOptions);
                    }
                    return setAsyncState({
                        [code]: ajaxOptions
                    });
                }
                setAsyncState({
                    [code]: resp.result.map(field => ({
                        label: field.value || "",
                        value: field.id || "",
                    })),
                });
            });
        }
    };

	function convertFieldConfigToProps(fieldConfig) {
        const getOptions = dict => dict.map(field => ({ label: field.value.trim(), value: field.key }));
        const multi =
            (["LIST", "THREE"].includes(fieldConfig.type) && fieldConfig.multiset_allowed === "Y") || undefined;
        const options =
            fieldConfig.type === "THREE"
                ? { children: buildThreePath(fieldConfig.dict, false, { children: "children" }) }
                : getOptions(fieldConfig.dict || []);
        const searchable = !!fieldConfig.search;
        const isMultiset = fieldConfig.type === "THREE";
        const title = fieldConfig.type === "THREE" && fieldConfig.name;
        const clearValueText = t("clear");
        const clearAllText = t("clearValue");
        let config = {
            key: fieldConfig.id,
            component: getComponentByType(fieldConfig.type, fieldConfig.search, fieldConfig.multiset_allowed === "Y"),
            name: fieldConfig.code,
            label: fieldConfig.name,
            title,
            type: fieldConfig.type,
            options,
            multi,
            showValuesCount: multi,
            tree: fieldConfig.type === "THREE",
            errorPlaceholder: true,
            valueField: fieldConfig.type === "THREE" ? "value" : "key",
            keySelectField: "key",
            leafField: fieldConfig.type === "THREE" ? "leaf" : "children",
            searchable,
            isMultiset,
            clearValueText,
            clearAllText,
            placeholder: t("dontSelect"),
            noResultsText: t("noResultsFound"),
            // disabled: fixedFilterObject ? fixedFilterObject.find(obj => obj.id === fieldConfig.id) : false,
			disabled: false,
            hidden: fieldConfig.hidden,
            onBlur: e => {
                e.preventDefault();
                return false;
            },
            onChange: handleSubmit,
        };

        if (fieldConfig.dict_search) {
            const { disallow_select_all } = fieldConfig;

            config = {
                ...config,
                disallow_select_all,
                notFilteredOptions: true,
                dict_search: true,
                options: asyncState[fieldConfig.code] || [],
                async: {
                    callback: asyncParams,
                    code: fieldConfig.code,
                    id: fieldConfig.id,
                    type: fieldConfig.type
                },
            };

            if (fieldConfig.type === "THREE") {
                config.valueField = "key" // in static dict valueField is "value" (look on top)
            }
        }
        return config;
    }
	
	function onFilterChange (e) {
		// console.log(e.target);
	}
	
	function renderFilterSelect () {

		return (
			<ComboBox
				options={filterPresetList.length && filterPresetList.map( ({name, value}) => { return {value: value, label: name } }) }
				label={t('filters.useFilter')}
				name={'applyFilter'}
				value={props.currentFilter || EMPTY_FILTER_OPTION}
				onChange={onFilterChange}
				placeholder={t('dontSelect')}
				noResultsText={t('noResultsFound')}
			/>
		);
	}
	
	function renderField (fieldConfig) {
		let fieldProps = convertFieldConfigToProps(fieldConfig);
		
		if (fieldConfig.type === 'DATE') {
			fieldProps = { ...fieldProps, ...defaultPropsDate };
			return renderDateField(t, fieldConfig, fieldProps, formFilterValues);
		}
		
		return (
			<Field {...fieldProps} />
		);
	}


	return (
		<div className={cx('filter-form-wrapper', 'ordering-component-ui-core-wrapper')}>
			<div className='filter-head'> {t('filters.filters')}
			</div>
			<div className='scrollbox-modal'>
				<div className='scrollbox-content'>
					
						<Form
							className={'form-wrapper'}
							onSubmit={handleSubmit}
						>
							{isFilterListLoading && <Loader withContainer/>}
							{!isFilterListLoading && filterPresetList && renderFilterSelect()}
							{!isFilterListLoading && filterList && filterList.map(renderField)}
						</Form>
				</div>
			</div>
		</div>
	)
	
}
SearchModalFilter.propTypes = {
	handleSubmit: PropTypes.func,
	topicCode: PropTypes.string,
	typeCode: PropTypes.string
};

export default reduxForm({ destroyOnUnmount: true })(
	connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SearchModalFilter))
);

